import { User } from './User.model';
export class Servicer extends User {
  lastName: string;
  dataAssunzione: string;
  dataTermineContratto: string;
  constructor() {
    super();
  }
}
